import CryptoJS from 'crypto-js';
import AES from './AES.js'

export const Tool = {};

/* AES加密 */
Tool.Encrypt = (word) => {
    var key = CryptoJS.enc.Utf8.parse("httpliantuyuncom");
    var srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 });
    return encrypted.toString();
}